<template>
  <swiper :options="swiperOption">
    <slot></slot>
    <div class="swiper-pagination" v-if="pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
  export default {
    name: 'CSlider',
    props: {
      direction: {
        type: String,
        default: 'horizontal',
        validator(value) {
          return ['horizontal', 'vertical'].indexOf(value) > -1;
        },
      },
      autoplay: {
        type: Boolean,
        default: true,
      },
      interval: {
        type: Number,
        default: 3000,
        validator(value) {
          return value >= 0;
        },
      },
      loop: {
        type: Boolean,
        default: true,
      },
      spaceBetween: {
        type: Number,
        default: 0,
      },
      pagination: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        swiperOption: {
          watchOverFlow: true, // 当没有足够的slide切换时，例如只有1个slide，swiper会失效且隐藏导航等(loop模式无效，因为会复制slide)
          direction: this.direction,
          autoplay: this.autoplay
            ? {
              delay: this.interval,
              disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
            }
            : false,
          slidersPerView: 'auto', // 设置slider容器能够同时显示的slides数量(carousel模式),设置成'auto'则自动根据slides的宽度来设定数量
          spaceBetween: this.spaceBetween, // slide之间的距离（单位px）
          loop: this.autoplay ? this.loop : false,
          pagination: {
            el: this.pagination ? '.swiper-pagination' : null,
          },
        },
      };
    },
    created() {
      // console.log(this.swiperOption);
    },
  };
</script>
